var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, css, html, LitElement, property } from 'lit-element';
import i18n from 'roddeh-i18n';
import Auth from '../services/auth';
let AccountMini = class AccountMini extends LitElement {
    constructor() {
        super(...arguments);
        this.loggedIn = false;
        this.firstName = null;
    }
    static get styles() {
        return css `
            img {
                height: 2.2rem;
                flex-basis: 100%;
            }
            a {
                position: relative;
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                white-space: nowrap;
                transition: opacity 0.3s ease-out;
                margin: 0 auto;
                color: #fcf8f1;
                text-decoration: none;
            }

            a:hover::before {
                position: absolute;
                z-index: 2;
                left: 50%;
                top: 37px;
                display: block;
                width: 10px;
                height: 10px;
                background-color: #fff;
                content: '';
                box-shadow: 3px 4px 6px rgba(0, 0, 0, 0.3);
                transform: translate(-50%, -5px) rotate(45deg);
            }

            a:hover::after {
                z-index: 3;
                position: absolute;
                background-color: #fff;
                bottom: -2.5em;
                font-weight: normal;
                padding: 4px;
                color: #2a2a2a;
                content: attr(aria-label);
                box-shadow: 3px 4px 6px rgba(0, 0, 0, 0.3);
            }

            @media (max-width: 425px) {
                a:hover::after {
                    content: none;
                }
                a:hover::before {
                    content: none;
                }
            }

            a span {
                transition: border-color 0.3s ease-out;
                border-bottom: 1px solid transparent;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                max-width: 10em;
            }
            @media (max-width: 1000px) {
                img {
                    height: 3em;
                }
                span {
                    display: none;
                }
            }
            @media (max-width: 425px) {
                img {
                    height: 2.5em;
                }
            }
            a:hover > img,
            a:hover > span {
                opacity: 0.8;
            }
            a:hover > span {
                border-bottom: 1px solid var(--light-border-color);
            }
        `;
    }
    render() {
        return html ` <div>
            <a
                href="/customer"
                aria-label="${this.loggedIn ? `${i18n('NCP Welcome')} ${this.firstName}!` : `${i18n('My account')}`}"
                }
            >
                <img src="/img/header/icon/ico-user.svg" />
            </a>
        </div>`;
    }
    connectedCallback() {
        super.connectedCallback();
        // Jeżeli mamy w cache, ładujemy od razu ostatni stan zalogowania
        const lastState = Auth.getLastState();
        if (lastState !== null) {
            this.updateState(lastState);
        }
        // Przyszłościowo można rozważyć zaprzestanie odpytywania API co załadowanie strony
        this.updateSummary();
    }
    updateSummary() {
        Auth.getState()
            .then((state) => {
            this.updateState(state);
        })
            .catch((err) => {
            console.error('Failed to get auth state', err);
        });
    }
    updateState(state) {
        this.loggedIn = state.loggedIn;
        this.firstName = state.firstName;
    }
};
__decorate([
    property({ type: Boolean })
], AccountMini.prototype, "loggedIn", void 0);
__decorate([
    property({ type: String })
], AccountMini.prototype, "firstName", void 0);
AccountMini = __decorate([
    customElement('account-mini')
], AccountMini);
export default AccountMini;
